import { styled } from 'styletron-react';
import { Row } from 'react-bootstrap';

const SectionSeparator = styled(Row, {
  height: '72px'
});

export default SectionSeparator;
